import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import {HomeComponent} from './home/home.component';
import {VisionComponent} from './vision/vision.component';
import {AboutComponent} from './about/about.component';
import {CareersComponent} from './careers/careers.component';
import {ContactUsComponent} from './contact-us/contact-us.component';
import {ProductComponent} from './product/product.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';


const routes: Routes = [
  {path:'', component:HomeComponent},
  {path:'header', component:HeaderComponent},
  {path:'footer', component:FooterComponent},
  {path:'vision', component:VisionComponent},
  {path:'about', component:AboutComponent},
  {path:'careers', component:CareersComponent},
  {path:'contact_us', component:ContactUsComponent},
  {path:'product', component:ProductComponent},
  {path:'product/:id', component:ProductDetailComponent}


];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
